import { useAuth } from "@/contexts";
import { BsEnvelopeOpen } from "react-icons/bs";
import { FiAlertTriangle } from "react-icons/fi";
import { IoIosArrowBack, IoIosArrowForward, IoMdHome } from "react-icons/io";
import { MdPhone } from "react-icons/md";
import { MenuConnected, MenuDisconnected } from "./";

import { useAsynClientById } from "@/hooks/Client";
import { useAsyncBrandsData } from "@/hooks/Contents/useAsyncBrandsData";
import { useAsyncModelsByBrand } from "@/hooks/Contents/useAsyncModelsByBrand";
import { useAsyncRimsData } from "@/hooks/Contents/useAsyncRimsData";
import { useAsyncTiresData } from "@/hooks/Contents/useAsyncTiresData";
import { useAsyncYearsByModel } from "@/hooks/Contents/useAsyncYearsByModel";
import { useIsomorphicLayoutEffect } from "@/hooks/Custom";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  IconButton,
  Link,
  Select,
  SimpleGrid,
  Stack,
  Text,
  useToast,
  Image,
  Img
} from "@chakra-ui/react";
import Router from "next/router";
import { Key, useEffect, useState } from "react";

export function DrawerMenu({ DrawerPosition, placement, ...Data }) {
  const User = useAuth();
  const [Rims, setRims] = useState(null);
  const [Models, setModels] = useState(null);
  const [ModelsBF, setModelsBF] = useState(null);

  const [CarBrand, setCarBrand] = useState(null);
  const [SelectedBrand, setSelectedBrand] = useState(null);

  const [CarModel, setCarModel] = useState(null);
  const [SelectedModel, setSelectedModel] = useState(null);

  const [CarYear, setCarYear] = useState(null);
  const [SelectedYear, setSelectedYear] = useState(null);

  const [ModelOrder, setModelsOrder] = useState<any>();

  const HandleStaticContents = async () => {
    const [RimsData, RimsError] = await useAsyncRimsData("");
    const [TiresData, TiresError] = await useAsyncTiresData("menu-modelos-linglong");

    const [BrandsData, BrandsError] = await useAsyncBrandsData("");

    setRims(RimsData?.[0]?.contentsArray);
    setModels(TiresData?.[0]?.contentsArray);
    setCarBrand(BrandsData?.value);
  };

  const HandleDynamicModels = async () => {
    const [ModelsData, ModelsError] = await useAsyncModelsByBrand(SelectedBrand);
    setCarModel(ModelsData);
  };
  const HandleDynamicYears = async () => {
    const [YearsData, YearsError] = await useAsyncYearsByModel(SelectedModel, SelectedBrand);
    setCarYear(YearsData?.value);
  };

  const Toast = useToast({
    position: "bottom",
    isClosable: true,
    duration: 2000
  });

  const [userName, setUserName] = useState("USUÁRIO");
  async function getUserName(clientID: string) {
    const [UserData, UserError] = await useAsynClientById(clientID);
    if (UserData) {
      const IsPF = UserData?.hasOwnProperty("clientPFData");
      const UserName =
        UserData?.[IsPF ? "clientPFData" : "clientPJData"]?.[IsPF ? "name" : "nomeFantasia"]?.split(
          " "
        )[0];
      setUserName(UserName);
    } else {
      setUserName("USUÁRIO");
    }
  }

  function orderModels() {
    const Ordened = Models?.sort((a, b) => {
      if (a.model > b.model) {
        return 1;
      } else if (b.model > a.model) {
        return -1;
      } else {
        return 0;
      }
    });
    setModelsOrder(Ordened);
  }

  useEffect(() => {
    orderModels();
  }, [Models]);

  useIsomorphicLayoutEffect(() => {
    if (User?.clientId) {
      getUserName(User?.clientId);
    }
  }, [User]);

  const HandleSearchByVehicle = async (e) => {
    e.preventDefault();

    if (!SelectedBrand) {
      Toast({
        title: "Selecione uma marca para realizar a pesquisa.",
        status: "info",
        position: "bottom",
        duration: 5000,
        isClosable: true
      });
    } else if (!SelectedModel) {
      Toast({
        title: "Selecione um modelo para realizar a pesquisa.",
        status: "info",
        position: "bottom",
        duration: 5000,
        isClosable: true
      });
    } else if (SelectedBrand && SelectedModel) {
      Data.onClose();
      Router.push({
        pathname: "/pesquisa/veiculo",
        query: Boolean(SelectedYear)
          ? {
              brand: `${SelectedBrand}`,
              model: `${SelectedModel}`,
              year: `${SelectedYear ?? ""}`
            }
          : {
              brand: `${SelectedBrand}`,
              model: `${SelectedModel}`
            }
      });
      setSelectedBrand(null);
      setSelectedModel(null);
      setSelectedYear(null);
    }
  };

  useIsomorphicLayoutEffect(() => {
    HandleStaticContents();
  }, []);

  useIsomorphicLayoutEffect(() => {
    HandleDynamicModels();
  }, [SelectedBrand]);

  useIsomorphicLayoutEffect(() => {
    HandleDynamicYears();
  }, [SelectedModel]);

  return (
    <>
      <Drawer isOpen={Data.isOpen} placement={placement} onClose={Data.onClose}>
        <DrawerOverlay />
        <DrawerContent bg={"white"} letterSpacing={"-1px"}>
          <DrawerHeader display="flex" justifyContent="space-between" padding="5px 0">
            <Flex onClick={Data.onClose} alignItems="center" w="full" mt="-5px">
              <Button
                w={"full"}
                borderRadius={"0px"}
                h={"70px "}
                background={"linear-gradient(99.09deg, #0C4EA2 14.48%, #00A550 90.81%);"}
              >
                <Text color={"ll-white.main"}>VOLTAR</Text>
                <IoIosArrowForward color={"white"} />
              </Button>
            </Flex>
          </DrawerHeader>
          <Flex justifyContent={"center"} mt={"25px"}>
            <Text fontSize={"h3"} color={"ll-green.main"} fontWeight={"400"} letterSpacing={"-1px"}>
              Seja bem-vindo
            </Text>
          </Flex>
          <DrawerBody>
            <Link
              display={"flex"}
              alignItems={"center"}
              gap={"12px"}
              w={"full"}
              mb={"20px"}
              px={"20px"}
              py={"12px"}
              borderRadius={"50px"}
              bgColor={"#C8000D"}
              color={"ll-white.main"}
              _hover={{ textDecoration: "none", opacity: "0.9" }}
              onClick={() => {
                Data.onClose();
                Router.push("/como-identificar-fraude");
              }}
            >
              <FiAlertTriangle size={24} />
              <Flex direction={"column"} lineHeight={"1.2"}>
                <Text fontSize={"text1"} fontWeight={"700"} textTransform={"uppercase"}>
                  Fique ligado!
                </Text>
                <Text fontSize={"text3"}>Dicas para você não cair em golpes.</Text>
              </Flex>
            </Link>

            {/* Switch the type of drawer menu */}
            {User.isAuthenticated ? (
              <MenuConnected name={userName?.toUpperCase()} onClose={Data.onClose} />
            ) : (
              <MenuDisconnected onClose={Data.onClose} />
            )}

            <Flex mt={"10px"}>
              <Accordion allowToggle fontSize="text3" w={"full"}>
                {/* {console.log("RODAS========", Rims)} */}
                {Rims && (
                  <AccordionItem borderTopStyle="none" borderBottom={"1px dashed #ECECEC"}>
                    <AccordionButton>
                      <Flex align="center" justify="space-between" w="full">
                        <Flex color={"ll-blue.main"} fontSize={"h4"} fontWeight={"500"}>
                          AROS
                        </Flex>
                        <Flex
                          justifyContent={"center"}
                          alignItems={"center"}
                          minW={"28px"}
                          minH={"28px"}
                          bgColor={"ll-gray.100"}
                          borderRadius={"50px"}
                          mr={"5px"}
                        >
                          <Img
                            w={"12px"}
                            src={
                              "https://cdn.pneufree.com.br/LINGLONG/images/Geral/DESKTOP/arrow.svg"
                            }
                          />
                        </Flex>
                      </Flex>
                      {/* <Box
                        alignItems="left"
                        textStyle="Bold"
                        color="#1E1E1E"
                        letterSpacing="0.50rem"
                        _focus={{ boxShadow: "none" }}
                      >
                        AROS
                      </Box> */}
                    </AccordionButton>

                    <AccordionPanel pb={4}>
                      <Stack spacing="12px" textStyle="Regular" fontSize="text1">
                        <Flex
                          flex="2"
                          _hover={{
                            fontStyle: "none"
                          }}
                          color="#1E1E1E"
                          direction="column"
                          borderRightColor="gray.300"
                          borderRightStyle="solid"
                          borderRightWidth="2px"
                          pl="20px"
                        >
                          <Flex direction="column" w="80px">
                            {Rims?.map(
                              (
                                rim: {
                                  aro: string;
                                },
                                index: Key
                              ) => {
                                return (
                                  <Link
                                    key={index}
                                    className="menu__item"
                                    onClick={() => {
                                      Data.onClose();
                                      Router.push(
                                        `/pesquisa/PNEU?Rim=${rim.aro?.replaceAll("ARO", "")}`
                                      );
                                    }}
                                  >
                                    <Text mb="0.3rem">{rim.aro}</Text>
                                  </Link>
                                );
                              }
                            )}
                          </Flex>
                        </Flex>
                      </Stack>
                    </AccordionPanel>
                  </AccordionItem>
                )}

                {Models && (
                  <AccordionItem px={0} borderBottom={"1px dashed #ECECEC"}>
                    <h2>
                      <AccordionButton>
                        <Flex align="center" justify="space-between" w="full">
                          <Flex color={"ll-blue.main"} fontSize={"h4"} fontWeight={"500"}>
                            MODELOS
                          </Flex>
                          <Flex
                            justifyContent={"center"}
                            alignItems={"center"}
                            minW={"28px"}
                            minH={"28px"}
                            bgColor={"ll-gray.100"}
                            borderRadius={"50px"}
                            mr={"5px"}
                          >
                            <Img
                              w={"12px"}
                              src={
                                "https://cdn.pneufree.com.br/LINGLONG/images/Geral/DESKTOP/arrow.svg"
                              }
                            />
                          </Flex>
                        </Flex>
                        {/* <Box
                        alignItems="left"
                        textStyle="Bold"
                        color="#1E1E1E"
                        letterSpacing="0.50rem"
                        _focus={{ boxShadow: "none" }}
                      >
                        AROS
                      </Box> */}
                      </AccordionButton>
                    </h2>
                    <AccordionPanel pb={4} px={0}>
                      <Stack spacing="12px" textStyle="Regular" fontSize="text1">
                        <Flex
                          flex="4"
                          direction="column"
                          pl="20px"
                          rowGap={"2rem"}
                          borderRightColor="gray.300"
                          borderRightStyle="solid"
                          borderRightWidth="2px"
                        >
                          {ModelOrder && (
                            <Flex direction={"column"}>
                              <SimpleGrid columns={1} spacingX="20px" spacingY="0.3rem">
                                {ModelOrder?.map(
                                  (
                                    tires: {
                                      slug: any;
                                      model: any;
                                    },
                                    index: Key
                                  ) => {
                                    return (
                                      <Link
                                        key={index}
                                        className="menu__item"
                                        onClick={() => {
                                          Data.onClose();
                                          Router.push(`/${tires.slug}`);
                                        }}
                                        textStyle="NotoRegular"
                                        color="#1E1E1E"
                                      >
                                        {tires.model}
                                      </Link>
                                    );
                                  }
                                )}
                              </SimpleGrid>
                            </Flex>
                          )}
                        </Flex>
                      </Stack>
                    </AccordionPanel>
                  </AccordionItem>
                )}

                <AccordionItem borderBottom={"1px dashed #ECECEC"}>
                  <AccordionButton>
                    <Flex align="center" justify="space-between" w="full">
                      <Flex color={"ll-blue.main"} fontSize={"h4"} fontWeight={"500"}>
                        VEÍCULOS
                      </Flex>
                      <Flex
                        justifyContent={"center"}
                        alignItems={"center"}
                        minW={"28px"}
                        minH={"28px"}
                        bgColor={"ll-gray.100"}
                        borderRadius={"50px"}
                        mr={"5px"}
                      >
                        <Img
                          w={"12px"}
                          src={
                            "https://cdn.pneufree.com.br/LINGLONG/images/Geral/DESKTOP/arrow.svg"
                          }
                        />
                      </Flex>
                    </Flex>
                  </AccordionButton>

                  <AccordionPanel pb={4} padding="8px ">
                    <Flex as="form" onSubmit={HandleSearchByVehicle} direction="column" w="full">
                      <Select
                        _focus={{ borderColor: "#58585A", boxShadow: "none" }}
                        w="full"
                        borderRadius="50px"
                        mb="20px"
                        placeholder="MARCA"
                        onChange={(e) => setSelectedBrand(e.target.value)}
                      >
                        {CarBrand &&
                          CarBrand?.map((make: any, index: Key) => (
                            <option key={index} value={make.value}>
                              {make}
                            </option>
                          ))}
                      </Select>
                      <Select
                        _focus={{ borderColor: "#58585A", boxShadow: "none" }}
                        borderRadius="50px"
                        mb="20px"
                        placeholder="MODELO"
                        onChange={(e) => setSelectedModel(e.target.value)}
                      >
                        {CarModel && (
                          <>
                            {CarModel?.map((vehicle: string, index: Key) => (
                              <option key={index} value={vehicle}>
                                {vehicle}
                              </option>
                            ))}
                          </>
                        )}
                      </Select>
                      <Select
                        _focus={{ borderColor: "#58585A", boxShadow: "none" }}
                        borderRadius="50px"
                        mb="20px"
                        placeholder="ANO"
                        onChange={(e) => setSelectedYear(e.target.value)}
                      >
                        {CarYear &&
                          CarYear.length > 0 &&
                          CarYear?.map(
                            (
                              fabricationYear: {
                                year: string;
                              },
                              index: Key
                            ) => (
                              <option key={index} value={fabricationYear?.year}>
                                {fabricationYear?.year}
                              </option>
                            )
                          )}
                      </Select>
                      <Button type="submit" variant={"primary-button"}>
                        PESQUISAR
                      </Button>
                    </Flex>
                  </AccordionPanel>
                </AccordionItem>
              </Accordion>
            </Flex>

            <Flex direction="column" marginTop="0px" textStyle="Regular">
              <Stack direction="column" marginTop="20px" spacing="15px">
                <Link
                  color={"ll-gray.300"}
                  fontWeight={"500"}
                  _hover={{ textDecoration: "none", opacity: "0.5" }}
                  fontSize="h4"
                  onClick={() => {
                    Data.onClose();
                    Router.push("/ajuda/sobre");
                  }}
                  //passHref
                >
                  <Text>Quem somos</Text>
                </Link>
                <Link
                  color={"ll-gray.300"}
                  fontWeight={"500"}
                  _hover={{ textDecoration: "none", opacity: "0.5" }}
                  fontSize="h4"
                  onClick={() => {
                    Data.onClose();
                    Router.push("/ajuda/");
                  }}
                  //passHref
                >
                  Central de ajuda
                </Link>
                <Link
                  color={"ll-gray.300"}
                  fontWeight={"500"}
                  _hover={{ textDecoration: "none", opacity: "0.5" }}
                  fontSize="h4"
                  onClick={() => {
                    Data.onClose();
                    Router.push("/ajuda/privacidade-linglong");
                  }}
                  //passHref
                >
                  Política de privacidade
                </Link>

                <Link
                  color={"ll-gray.300"}
                  fontWeight={"500"}
                  _hover={{ textDecoration: "none", opacity: "0.5" }}
                  fontSize="h4"
                  onClick={() => {
                    Data.onClose();
                    Router.push("/ajuda/contato-linglong");
                  }}
                  //passHref
                >
                  Contato
                </Link>
              </Stack>
              <Box borderBottom="2px" marginTop="30px" borderColor="gray.300" />
            </Flex>

            <Flex alignItems="start" flexDirection="column" marginBottom="30px" overflowY="hidden">
              <Flex direction="column" mt={"15px"}>
                <Text color={"ll-blue.main"} fontSize={"h2"} fontWeight={"500"}>
                  VENDAS
                </Text>
                <Flex flexDir={"column"} color={"ll-gray.300"} fontSize={"text1"}>
                  <Text mb="1rem" color={"ll-green.main"}>
                    Dias úteis das 8h às 18h.
                  </Text>
                  <Link
                    _hover={{ textDecoration: "none", opacity: "0.5" }}
                    display="flex"
                    mb="10px"
                    href="tel:+5504140421100"
                    //passHref
                  >
                    <Img
                      src="https://cdn.pneufree.com.br/LINGLONG/images/Site/icons/phone.svg"
                      mr="10px"
                      width="21px"
                      height="21px"
                      alt="Phone Vendas"
                    />
                    <Text>(41) 4042-1100</Text>
                  </Link>

                  <Link
                    _hover={{ textDecoration: "none", opacity: "0.5" }}
                    display="flex"
                    href="mailto:sac@linglong.com.br"
                  >
                    <Img
                      src="https://cdn.pneufree.com.br/LINGLONG/images/mail.svg"
                      mr="10px"
                      width="21px"
                      height="21px"
                      alt="Email vendas"
                    />
                    <Text>sac@linglong.com.br</Text>
                  </Link>
                </Flex>
              </Flex>

              <Flex direction="column" mt={"15px"}>
                <Text color={"ll-blue.main"} fontSize={"h2"} fontWeight={"500"}>
                  PÓS-VENDAS
                </Text>
                <Text color={"ll-green.main"} fontSize={"text1"} mb="1rem">
                  Dias úteis das 8h às 18h.
                </Text>

                <Flex flexDir={"column"} color={"ll-gray.300"} fontSize={"text1"}>
                  <Link
                    _hover={{ textDecoration: "none", opacity: "0.5" }}
                    display="flex"
                    mb="10px"
                    href="tel:+55040421212"
                  >
                    <Img
                      src="https://cdn.pneufree.com.br/LINGLONG/images/Site/icons/phone.svg"
                      mr="10px"
                      width="21px"
                      height="21px"
                      alt="Phone Pós-Vendas"
                    />
                    <Text>(41) 4042-1212</Text>
                  </Link>

                  <Link
                    _hover={{ textDecoration: "none", opacity: "0.5" }}
                    display="flex"
                    href="mailto:sac@linglong.com.br"
                    //passHref
                  >
                    <Img
                      src="https://cdn.pneufree.com.br/LINGLONG/images/mail.svg"
                      mr="10px"
                      width="21px"
                      height="21px"
                      alt="Email Pós-Vendas"
                    />
                    <Text>sac@linglong.com.br</Text>
                  </Link>
                </Flex>
              </Flex>
            </Flex>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
}
